import React from "react";

import { Main, Bold } from "../styles";

export default function Answer() {
  return (
    <Main>
      <Bold as="h1" style={{ fontSize: 22 }} color="#4B4B4B">
        Sinalização do veículo (Identificação de unidades de transporte)
      </Bold>
      <p>
        A - Sinalização do veículo ABNT NBR 7500: Painéis de Segurança do
        produto ONU 1075 em perfeito estado de conservação e afixados nos locais
        corretos.
      </p>
      <p>
        B - Rótulos de risco da Subclasse 2.1 (Gás Inflamável) em perfeito
        estado de conservação e afixados nos locais corretos.
      </p>
      <p>
        C - Código de registro (ANTT) – Registro Nacional de Transportadores
        Rodoviários de Cargas (RNTRC) para todos os veículos categoria “aluguel”
        (placa vermelha): É OBRIGATÓRIA a apresentação, pelo transportador ou
        pelo condutor do CRNTRC – Certificado de Registro Nacional de
        Transportadores Rodoviários de Cargas em tamanho natural ou reduzido,
        desde que legível. O transportador que transporta exclusivamente carga
        própria (categoria particular – placa cinza), ou seja, não presta
        serviço de transporte rodoviário remunerado de cargas para terceiros não
        tem que se registrar no RNTRC.
      </p>
    </Main>
  );
}
